import React from 'react';
import { VisuallyHidden } from '@leagueplatform/genesis-commons';
import { Box, Modal, styled } from '@leagueplatform/genesis-core';

const DEFAULT_HEADER_HEIGHT = '50px';

const modalTitleId = 'iframe-modal-title';

type IframeModalProps = {
  onClose?: () => void;
  children: React.ReactNode;
  title?: string;
  headerHeight?: string;
};

const ContentWrapper = styled(Box, {
  overflow: 'hidden',
  position: 'relative',
  maxWidth: '895px',
  maxHeight: '669px',
  height: '80vh',
  '@mobile': {
    maxWidth: '100%',
    maxHeight: '100%',
    height: '100%',
  },
});

const ModalBody = styled(Box, {
  width: '100%',
});

export const IframeModal = ({
  onClose,
  children,
  headerHeight = DEFAULT_HEADER_HEIGHT,
  title,
}: IframeModalProps) => (
  <Modal.Root
    defaultOpen
    onOpenChange={(open) => {
      if (!open && onClose) {
        onClose();
      }
    }}
  >
    <Modal.Content
      showCloseButton={!!onClose}
      aria-labelledby={title ? modalTitleId : undefined}
      css={{
        '.GDS-modal': {
          zIndex: 7000,
          width: '100%',
          maxWidth: '950px',
          '@mobile': {
            top: 0,
            bottom: 0,
            maxHeight: '100%',
            borderRadius: 0,
          },
        },
        '.GDS-modal-overlay': { zIndex: 7000 },
        '.GDS-modal-close-button-wrapper': {
          padding: '$half',
        },
        '.GDS-modal-content': {
          '@mobile': { padding: '$none' },
        },
      }}
    >
      <Modal.Title>
        <VisuallyHidden>{modalTitleId}</VisuallyHidden>
      </Modal.Title>
      <ContentWrapper>
        {/* Header Block - only show if title exists */}
        {title && (
          <Modal.Title asChild>
            <VisuallyHidden id={modalTitleId}>{title}</VisuallyHidden>
          </Modal.Title>
        )}
        {/* Modal Body */}
        <ModalBody
          css={{
            height: title ? `calc(100% - ${headerHeight})` : '100%',
            '@mobile': { height: '100%' },
          }}
          tabIndex={0}
        >
          {children}
        </ModalBody>
      </ContentWrapper>
    </Modal.Content>
  </Modal.Root>
);
